import { useQuery } from '@apollo/client';
import { QueryHookOptions } from '@apollo/client/react/types/types';
import gql from 'graphql-tag';

import { HOME_OPS_TRIPPY_DOMAIN } from '../../../utils/constants';
import { SearchVisits } from '../../athena/types/SearchVisits';
import { VISIT_FIELDS } from '../../fragments/trippy/visitFields';

export const SEARCH_VISITS = gql`
  query SearchVisits(
    $orderings: [OdProtosTrippyData_VisitOrderingInput!]
    $pagination: OdProtosCommonPagination_PaginationRequestInput!
    $assignedOrganizationIds: [String!]
    $cancelledAt: OdProtosTrippyServices_TimestampParamInput
  ) {
    trippy {
      searchVisits(input: {
        pagination: $pagination
        ordering: $orderings
        assignedOrganizationIds: $assignedOrganizationIds
        cancelledAt: $cancelledAt
        domainIds: ["${HOME_OPS_TRIPPY_DOMAIN}"]
      }) {
        pagination {
          cursors
        }
        resultCount
        visits {
          ...VisitFields
        }
      }
    }
  }

  ${VISIT_FIELDS}
`;

const useSearchVisits = (options?: QueryHookOptions<SearchVisits>) =>
  useQuery<SearchVisits>(SEARCH_VISITS, options);

export default useSearchVisits;
